import { Controller } from "@hotwired/stimulus"

// Le righe «Scegli fattura» di un pagamento (Pagamento di components/rendicontazione/Pagamenti.js, 31a5bd1).
// Una riga = la fattura scelta (pagamento-fattura-scelta) e l'importo (pagamento-importo), che compare con più di una
// riga o se l'importo non è letto nel documento, mai per un estratto conto. Le proposte del programma si vedono solo
// senza righe; «Conferma» (pagamento-conferma) solo con almeno una riga; «Togli» toglie la riga. L'importo nascosto è
// disattivato: non parte col form (il server lo legge come null: un pagamento su una fattura sola prende tutto l'importo).
// Le righe nascono dal <template> (nomi fatture[N][fattura_id] / fatture[N][importo], N crescente).
export default class extends Controller {
  static targets = ["righe", "modello", "riga", "importo", "conferma", "proposte", "piuFatture"]
  static values = { riscontro: Boolean, importoLetto: Boolean }

  connect() {
    this.n = 0
    this.aggiorna()
  }

  aggiungi() {
    const html = this.modelloTarget.innerHTML.replaceAll("__N__", String(this.n++))
    this.righeTarget.insertAdjacentHTML("beforeend", html)
    this.aggiorna()
  }

  togli(event) {
    event.target.closest("[data-collegamenti-editor-target='riga']")?.remove()
    this.aggiorna()
  }

  aggiorna() {
    const righe = this.righeTarget.querySelectorAll("[data-collegamenti-editor-target='riga']")
    const conImporto = (righe.length > 1 || !this.importoLettoValue) && !this.riscontroValue
    righe.forEach((r) => {
      const campo = r.querySelector("[data-collegamenti-editor-target='importo']")
      if (!campo) return
      campo.hidden = !conImporto
      campo.disabled = !conImporto
    })
    this.confermaTargets.forEach((b) => { b.hidden = righe.length === 0 })
    this.proposteTargets.forEach((el) => { el.hidden = righe.length > 0 })
    this.piuFattureTargets.forEach((el) => { el.hidden = !(righe.length > 1 && !this.riscontroValue) })
  }
}
